const IPFS_GATEWAYS = [
    "https://hashpack.b-cdn.net/ipfs/",
    "https://cloudflare-ipfs.com/ipfs/",
    "https://ipfs.io/ipfs/",
];
const CID_V0 = /^Qm[1-9A-HJ-NP-Za-km-z]{44,}$/;
const CID_V1 = /^baf[a-z2-7]{20,}$/i;
export function isBareIpfsCid(value) {
    const t = value.trim();
    return CID_V0.test(t) || CID_V1.test(t);
}
export function ipfsUriToHttp(uri) {
    const trimmed = uri.trim();
    if (trimmed.startsWith("ipfs://ipfs/")) {
        return ipfsUriToHttp(`ipfs://${trimmed.slice("ipfs://ipfs/".length)}`);
    }
    if (trimmed.startsWith("ipfs://")) {
        return `${IPFS_GATEWAYS[0]}${trimmed.slice("ipfs://".length)}`;
    }
    if (trimmed.startsWith("ar://")) {
        return `https://arweave.net/${trimmed.slice("ar://".length)}`;
    }
    if (isBareIpfsCid(trimmed)) {
        return `${IPFS_GATEWAYS[0]}${trimmed}`;
    }
    return trimmed;
}
